module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<= 4.06"},{"quantity":0.03,"color":"#91E3AD","label":"4.06 - 4.86"},{"quantity":0.06,"color":"#DEFFB0","label":"4.86 - 5.85"},{"quantity":0.01,"color":"#FFE68C","label":"5.85 - 6.96"},{"quantity":9,"color":"#FF9982","label":"6.96 - 8.7"},{"quantity":12,"color":"#FF4D30","label":"8.7 - 14.31"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_100_maize.json
// module id = fQnX
// module chunks = 171